module.exports = __webpack_public_path__ + "img/unitex_logo.ff990ccc.svg";